// removed by extract-text-webpack-plugin
module.exports = {"popoverWrapper":"CentricUI__view__TabButton__popoverWrapper","root":"CentricUI__view__TabButton__root","innerContainer":"CentricUI__view__TabButton__innerContainer","groupLabelBorderContainer":"CentricUI__view__TabButton__groupLabelBorderContainer","leading":"CentricUI__view__TabButton__leading","tabMenu":"CentricUI__view__TabButton__tabMenu","renameInput":"CentricUI__view__TabButton__renameInput","newTabButton":"CentricUI__view__TabButton__newTabButton"};


//////////////////
// WEBPACK FOOTER
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/TabButton.css
// module id = 966
// module chunks = 10